/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=2b7f1482&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2b7f1482&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-yunxiaobao-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7f1482"]])

export default __exports__